import { alpha, useTheme } from '@mui/material/styles';
import Box, { BoxProps } from '@mui/material/Box';
import { ReactNode } from 'react';
import HeroCardBackground from '../../assets/hero-background.webp';
import Typography from '@mui/material/Typography';

type ExamHeroProps = BoxProps & {
  title?: string;
  description?: string;
  img?: ReactNode;
  action?: ReactNode;
};

export const HeroCard = ({
  title,
  description,
  img,
  action,
  sx,
  ...other
}: ExamHeroProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={[
        {
          pt: 5,
          pb: 5,
          pr: 3,
          gap: 5,
          borderRadius: 2,
          display: 'flex',
          height: { md: 1 },
          position: 'relative',
          pl: { xs: 3, md: 5 },
          alignItems: 'center',
          color: 'common.white',
          textAlign: { xs: 'center', md: 'left' },
          flexDirection: { xs: 'column', md: 'row' },
          border: `solid 1px ${theme.palette.grey[800]}`,
          backgroundImage: `
            linear-gradient(
              to right,
              ${alpha(theme.palette.grey[900], 0.75)} 0%,
              ${theme.palette.grey[900]} 75%
            ),
            url(${HeroCardBackground})
          `,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <Box
        sx={{
          display: 'flex',
          flex: '1 1 auto',
          flexDirection: 'column',
          alignItems: { xs: 'center', md: 'flex-start' },
        }}
      >
        <Typography variant="h3" sx={{ whiteSpace: 'pre-line', mb: 1 }}>
          {title}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            opacity: 0.8,
            ...(action && { mb: 3 }),
          }}
        >
          {description}
        </Typography>

        {action}
      </Box>

      {img && <Box sx={{ maxWidth: 260 }}>{img}</Box>}
    </Box>
  );
};
